import "./livereload";

import { ConfigProvider } from "antd";
import frFR from "antd/es/locale/fr_FR";
import i18n from "i18next";
import mapboxgl from "mapbox-gl";
import React from "react";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";

import translations from "../translations";
import { autoRefreshTokens } from "./boot/auth";
import { init as initDayjs } from "./boot/dayjs";
import theme from "./theme";

import App from "./App";

// Init dayjs
initDayjs();

// Init mapbox
mapboxgl.accessToken = "pk.eyJ1Ijoia2VlbWF0aWMiLCJhIjoiY2xrcXhhZWQwMDU3bDNlcGs5ZXZ2MDd1YSJ9.L5uxh8pqye2txPRvKULkPw";

// Condigure sentry
// eslint-disable-next-line no-undef
const isLocalHost = /^(localhost|127\.0\.0\.1|\[?::1\]?)$/i.test(window.location.hostname);
if (process.env.NODE_ENV !== "development" && !isLocalHost) {
  (async () => {
    const [Sentry, { CaptureConsole }, { Integrations }] = await Promise.all([
      import("@sentry/react"),
      import("@sentry/integrations"),
      import("@sentry/tracing"),
    ]);

    Sentry.init({
      dsn: "https://744dfb1324a84c2a9cdbf925bc70ba94@sentry.infra.keematic.com/6",
      integrations: [
        new Integrations.BrowserTracing(),
        new CaptureConsole({
          levels: ["error"],
        }),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  })();
}

// Init i18n
i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: translations.fr,
    },
    en: {
      translation: translations.en,
    },
  },
  lng: "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

// auth refresh tokens @TODO: async ?
autoRefreshTokens();

const appContainer = document.getElementById("app");
const root = createRoot(appContainer);
root.render(
  <ConfigProvider locale={frFR} theme={theme}>
    <App />
  </ConfigProvider>,
);
